// extracted by mini-css-extract-plugin
export default {"table":"Table_table__zAB9b","filterCollapse":"Table_filterCollapse__PNClD"};